import {
  DataService,
  GetProductVariantDocument,
  I18nService,
  ModalService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { UpdateSkuDialogComponent } from "../../update-sku-dialog/update-sku-dialog.component";
import { take } from "rxjs";
import {
  DeletePackageReviewOrderLineDocument,
  GetProductVariantPackageReviewDocument,
  UpdatePackageReviewOrderLineDocument,
} from "src/generated-gql/graphql";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";

@Component({
  selector: "package-review-order-expand-content",
  standalone: true,
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.scss"],
  imports: [SharedModule],
})
export default class PackageReviewOrderExpandContent {
  @Input() item: {
    orderId: string;
    order: {
      code: string;
      orderId: string;
      x;
    };
    lines: any[];
  };
  @Input() index: number;

  // solve TypeError: Cannot assign to read only property 'quantity' of object '[object Object]'
  @Input()
  inDetail: boolean;

  @Input()
  readonly: boolean = false;

  @Output()
  editLine = new EventEmitter();

  constructor(
    private modalService: ModalService,
    private dataService: DataService,
    protected translateService: I18nService
  ) {}

  getLines() {



    return [...this.item.lines].sort((a, b) => {
      const left = Number.parseInt(a.id);
      const right = Number.parseInt(b.id);

      return left - right;
    });
  }

  editSku(line: any) {
    this.modalService
      .fromComponent(UpdateSkuDialogComponent, {
        size: "lg",
        locals: {
          currentVariant: line.productVariant,
          orderCode: this.item.order.code,
          orderId: this.item.orderId,
          currentQuantity: line.quantity,
          title: this.translateService.translate("package.update-sku"),
        },
      })
      .pipe(take(1))
      .subscribe((res) => {
        console.log(res);
        if (res) {
          const { variant, quantity } = res;

          this.dataService
            .mutate(UpdatePackageReviewOrderLineDocument, {
              input: {
                id: line.id,
                productVariantId: variant ? variant.productVariantId : undefined,
                quantity: quantity,
              },
            })
            .pipe(take(1))
            .subscribe((response) => {
              if (response.updatePackageReviewOrderLine) {
                this.editLine.emit(this.item);
              }
            });

          // if (variant) {
          //   this.dataService
          //     .query(GetProductVariantPackageReviewDocument, {
          //       id: variant.productVariantId,
          //     })
          //     .single$.pipe(take(1))
          //     .subscribe((variant) => {
          //       if (this.inDetail) {
          //         const newClonedOrderLines = [...this.item.cloneOrderLines];
          //         const newLine = newClonedOrderLines.find(
          //           (l) => l.productVariant.id === line.productVariant.id
          //         );

          //         newLine.productVariant = variant.productVariant;
          //         newLine.quantity = quantity;

          //         this.editLine.emit({
          //           ...this.item,
          //           cloneOrderLines: newClonedOrderLines,
          //         });
          //       } else {
          //         line.productVariant = variant.productVariant;
          //         line.quantity = quantity;

          //         this.editLine.emit(this.item);
          //       }
          //     });
          // } else {
          //   if (this.inDetail) {
          //     const newClonedOrderLines: any[] = [];

          //     for (const oldLine of this.item.cloneOrderLines) {
          //       if (oldLine.productVariant.id === line.productVariant.id) {
          //         newClonedOrderLines.push({
          //           ...oldLine,
          //           quantity: quantity,
          //         });
          //       } else {
          //         newClonedOrderLines.push(oldLine);
          //       }
          //     }

          //     this.editLine.emit({
          //       ...this.item,
          //       cloneOrderLines: newClonedOrderLines,
          //     });
          //   } else {
          //     line.quantity = quantity;

          //     this.editLine.emit(this.item);
          //   }
          // }
        }
      });
  }

  removeSku(line: any) {
    this.modalService
      .dialog({
        title: "Remove from Package reivew ?",
        buttons: [
          { label: "Cancel", type: "secondary", returnValue: false },
          { label: "Remove", type: "danger", returnValue: true },
        ],
        body: `Remove "${line.productVariant.translations[0].name}" from this package reivew?`,
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.dataService
            .mutate(DeletePackageReviewOrderLineDocument, {
              id: line.id,
            })
            .pipe(take(1))
            .subscribe((response) => {
              if (response.deletePackageReviewOrderLine) {
                this.editLine.emit(this.item);
              }
            });

          // if (this.inDetail) {
          //   const newClonedOrderLines: any[] = [];

          //   for (const oldLine of this.item.cloneOrderLines) {
          //     if (oldLine.productVariant.id === line.productVariant.id) {
          //       // ignore
          //     } else {
          //       newClonedOrderLines.push(oldLine);
          //     }
          //   }

          //   this.editLine.emit({
          //     ...this.item,
          //     cloneOrderLines: newClonedOrderLines,
          //   });
          // } else {
          //   this.item.cloneOrderLines = this.item.cloneOrderLines.filter(
          //     (l) => l.productVariant.id === line.productVariant.id
          //   );

          //   this.editLine.emit(this.item);
          // }
        }
      });
  }
}
